import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';

import { datetimeFormat } from 'app/constants/date-time-format';
import { DateService, HelperService, HTTPService } from 'app/services';

@Component({
  selector: 'app-date-filter',
  templateUrl: './date-filter.component.html',
  styleUrls: ['./date-filter.component.scss'],
})
export class DateFilterComponent implements OnInit {
  @Input() period: string = 'day';
  @Input() selectedDateTime: any = '';
  @Input() currentLang: string = 'en';
  @Input() isTechApp = false;
  @Input() isPeriodSelectionVisible = true;
  @Input() minimumDate: any;
  @Input() token: any;
  @Input() isDashboard = false;
  @Input() makretingDashboard = false;
  @Input() defaultDate: Date;


  @Output() appChangeActiveView = new EventEmitter();
  @Output() appClickPrevious = new EventEmitter();
  @Output() appClickNext = new EventEmitter();
  @Output() appChange = new EventEmitter();

  currentDatetime: any = '';
  title: string = '';
  id: string = 'this-week';
  filterTitle: string = 'This week';
  momentPeriod = {
    day: 'days',
    week: 'weeks',
    month: 'months',
    year: 'year',
  };

  constructor(private dateService: DateService, private httpService: HTTPService, private helpService: HelperService) { }

  ngOnInit() {
    this.httpService.getServerTime(this.token).then(
      (serverTime: any) => {
        this.currentDatetime = this.dateService.getCurrentDateTimeTz(serverTime);
        if (!this.selectedDateTime) {
          this.selectedDateTime = this.defaultDate ? new Date(this.defaultDate) : new Date(serverTime);
          this.setViewDate(this.selectedDateTime);
        }
      },
      (err) => {
        this.helpService.showToaster('error', err);
      }
    );
  }


  changePeriod(period: string, type, title) {
    this.id = type;
    this.filterTitle = title;
    this.period = period;
    this.appChangeActiveView.emit(period);
    this.selectedDateTime = new Date(this.currentDatetime);
    this.setViewDate(this.selectedDateTime);
  }

  handleNavigation(type: string) {
    const datetime = this.dateService.addDaysInDatetime(this.selectedDateTime, type === 'next' ? 1 : -1, this.momentPeriod[this.period], '');
    this.selectedDateTime = new Date(datetime);
    this.setViewDate(this.selectedDateTime);

    if (type === 'next') {
      this.appClickPrevious.emit();
    } else {
      this.appClickPrevious.emit();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if ((changes.currentLang && !changes.currentLang.firstChange) ||
      (changes.selectedDateTime && !changes.selectedDateTime.firstChange)) {
      this.setViewDate(this.selectedDateTime);
    }
  }

  onSelectDate(datetime: any, type, title) {
    this.id = type;
    this.filterTitle = title
    this.selectedDateTime = datetime;
    this.setViewDate(datetime);
  }

  openDatePicker() {
    if (this.makretingDashboard) return
    const element: HTMLElement = document.querySelector(`.calendar-date-picker input`) as HTMLElement;
    element.click();
  }

  setViewDate(datetime: string) {
    let startDate = '';
    let endDate = '';

    switch (this.period) {
      case 'day':
        startDate = this.dateService.formatDate(datetime, datetimeFormat.yyymmdd);
        endDate = this.dateService.formatDate(datetime, datetimeFormat.yyymmdd);

        this.title = this.dateService.formatDate(datetime, datetimeFormat.mmmdyyyy, this.currentLang);
        break;

      case 'month':
        startDate = this.dateService.startOfMonth(datetime, datetimeFormat.yyymmdd);
        endDate = this.dateService.endOfMonth(datetime, datetimeFormat.yyymmdd);

        // this.title = this.dateService.formatDateRange(
        //   `${startDate}T00:00:00`,
        //   `${endDate}T00:00:00`,
        //   true
        // );
        this.title = this.dateService.formatDate(datetime, datetimeFormat.mmmyyyy, this.currentLang);
        break;

      case 'week':
        const start = this.dateService.getStartOfThisWeek(new Date(datetime).setHours(0, 0, 0, 0), datetimeFormat.mmmdyyyy);
        const end = this.dateService.addDaysInDatetime(new Date(start).setHours(0, 0, 0, 0), 6, this.momentPeriod.day, datetimeFormat.mmmdyyyy);
        startDate = this.dateService.formatDate(new Date(start), datetimeFormat.yyymmdd);
        endDate = this.dateService.formatDate(new Date(end), datetimeFormat.yyymmdd);

        this.title = this.dateService.formatDateRange(`${startDate}T00:00:00`, `${endDate}T00:00:00`, true, this.currentLang);
        break;

      case 'year':
        startDate = this.dateService.startOfYear(datetime, datetimeFormat.yyymmdd);
        endDate = this.dateService.endOfYear(datetime, datetimeFormat.yyymmdd);

        this.title = this.dateService.formatDateRange(`${startDate}T00:00:00`, `${endDate}T00:00:00`, true, this.currentLang);
        break;

      default:
        return;
    }

    if (this.isDashboard) {
      this.filterTitle = 'Custom';
      this.id = "custom";
    }

    this.helpService.saveLocalStorage('retain-date', {
      startDate,
      endDate,
      id: this.id,
      filterTitle: this.filterTitle,
    });

    this.appChange.emit({
      startDate,
      endDate,
      period: this.period,
    });
  }
}
